<ng-container *transloco="let t">
  @let patient = patient$ | async;
  @let isDataLoaded = isDataLoaded$ | async;
  @let isArchived = isArchived$ | async;

  <pxc-filter-buttons />

  @if (isDataLoaded) {
    <pxc-telemonitoring-list
      data-testid="telemonitoring-list"
      [actions]="actions"
      [displayPatient]="false"
      [isArchived]="isArchived">
      @if (patient) {
        <button
          class="max-md:w-full"
          data-testid="start-telemonitoring"
          size="s"
          tuiButton
          type="button"
          [disabled]="patient.isArchived"
          (click)="createTelemonitoring()">
          {{ t('Démarrer un télésuivi') }}
        </button>
      }
    </pxc-telemonitoring-list>
  } @else {
    <pxc-loader class="my-4 block" data-testid="loading">
      {{ t('Chargement des télésuivis ...') }}
    </pxc-loader>
  }
</ng-container>
